import { Box } from "@memorang/ui";

interface Props {
	cards: React.ReactElement[];
}
const ReportCardsContainer = ({ cards }: Props) => <Box gap={16}>{cards}</Box>;

export default ReportCardsContainer;
